var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{attrs:{"prop":_vm.prop,"label":_vm.label,"width":_vm.width,"min-width":_vm.minWidth,"align":_vm.align,"fixed":_vm.fixed,"class-name":_vm.noFocus?'no-focus':''},scopedSlots:_vm._u([{key:"default",fn:function({row,$index}){return [_vm._t("default",null,null,{row,$index})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }